angular.module('rjmNg.controllers').controller('chartSaveAsCtrl', [
  "$scope"
  "$routeParams"
  "$modal"
  "Charts"
  "Figures"
  "app"
  "dashboardService"
  "DashboardItem"
  "enums"
  (
    $scope,
    $routeParams,
    $modal,
    Charts,
    Figures,
    app,
    dashboardService,
    DashboardItem,
    enums
  ) ->
    $scope.error = null
    $scope.isImport = $scope.isImport
    $scope.chart = $scope.chart
    $scope.figure = $scope.figure
    $scope.name = $scope.chart?.name ? $scope.figure?.name
    $scope.dashboardId = dashboardService.dashboard.id
    $scope.dashboards = app.getDashboards()
    userId = app.getUserId()

    _updateFigureCache = (figureId) ->
      requestOptions = Figures.getRequestOptions(true, true)
      if $routeParams.dashId?
        requestOptions.params.dashboardId = $routeParams.dashId
      Figures.get(figureId, true, requestOptions).then (response) ->

    _createDashboardItemFromFigure = (figure, modal, emitAdded = false) ->
      resourceParams =
        clientId: app.getClientId()
        id: null

      dashboardItem =
        clientId: app.getClientId()
        id: null
        figureId: figure.id
        chartId: null
        dashId: $scope.dashboardId

      DashboardItem.save(resourceParams, dashboardItem, (successResponse) ->
        modal('hide') # Hide the modal if succesful Dashboard item creation
        if emitAdded then $scope.$emit('chartOrFigureAdded', {dcid: successResponse.id})
      , (errorResponse) ->
        $scope.error = errorResponse.data.error
      )

    _saveAsChart = (modal) ->
      Charts.saveAs($scope.chart
        , $scope.name
        , app.getUserId()
        , $scope.dashboardId
        ).then (newChart) ->
          modal('hide')
        , (data, status) ->
          $scope.error = data.data.error

    _saveAsFigure = (modal) ->
        figure = angular.extend({}, $scope.figure)
        figure.id = null
        # use the existing query via the rjqlId
        figure.query = null
        figure.name = $scope.name
        figure.userId = userId
        delete figure.data
        # Create a new figure
        Figures.create(figure).then (newFigure) ->
          _updateFigureCache(newFigure.id)

          emitAdded = $scope.dashboardId is $routeParams.dashId
          _createDashboardItemFromFigure(newFigure, modal, emitAdded)
          # This will re-populate the Add Report list with the new figure.  We'll need
          # to move this into figure model once we are in a post-NewChart world.
          Charts.getCharts(true)

        , (data, status) ->
          $scope.error = data.data.error

    $scope.saveAs = (modal) ->
      #do not allow empty names
      if $scope.name?.length is 0
        $scope.error = "Name must contain at least one character"
        return

      if $scope.chart?
        _saveAsChart(modal)
      else if $scope.figure?
        _saveAsFigure(modal)

    $scope.isEditableDashboard = (dashboard) ->
      dashboard.userId is userId or dashboard.permission is enums.DASHBOARD_PERMISSION.EDIT
])
